<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="awards__background module__background"
        ></app-modulebackground>
        <div
            class="awards__container module__container"
            v-bind:class="{
                container__boxed: [5, 6].includes(module.layout.type),
                'container__boxed--half': [1, 2, 3, 4].includes(module.layout.type)
            }"
        >
            <div class="awards__inner module__inner">
                <div class="awards__inner--main module__inner--main">
                    <div
                        class="awards__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="awards__inner-col module__inner-col">
                            <div class="awards__header module__header">
                                <h2
                                    class="awards__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="awards__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="awards__inner-row module__inner-row">
                        <div class="awards__inner-col module__inner-col">
                            <div class="awards__content-block module__content-block">
                                <div
                                    class="awards__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [5, 6].includes(module.layout.type)
                                    }"
                                    v-if="
                                        module.data.text ||
                                            ([5, 6].includes(module.layout.type) &&
                                                module.data.link &&
                                                module.data.link.active === true)
                                    "
                                >
                                    <div
                                        class="awards__inner-row module__inner-row"
                                        v-if="module.data.text"
                                    >
                                        <div class="awards__inner-col module__inner-col">
                                            <div
                                                class="awards__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="awards__inner-row module__inner-row"
                                        v-if="
                                            [5, 6].includes(module.layout.type) &&
                                                module.data.link &&
                                                module.data.link.active === true
                                        "
                                    >
                                        <div class="awards__inner-col module__inner-col">
                                            <div class="awards__cta module__cta">
                                                <app-modulebutton
                                                    v-if="[5, 6].includes(module.layout.type)"
                                                    :data="module.data.link"
                                                    :custom-class="
                                                        'awards__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="awards__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [5, 6].includes(module.layout.type)
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="awards__inner-row module__inner-row">
                                        <div class="awards__inner-col module__inner-col">
                                            <div
                                                ref="slider"
                                                per-page="1"
                                                per-page-lg="1"
                                                per-page-md="1"
                                                per-page-sm="1"
                                                class="awards__list-wrap"
                                                v-bind:class="{
                                                    slider:
                                                        [1, 2].includes(module.layout.type) &&
                                                        items.length > 1
                                                }"
                                            >
                                                <ul
                                                    class="awards__list"
                                                    v-bind:class="{
                                                        module__list: [3, 4, 5, 6].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                >
                                                    <li
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        class="awards__list-item module__list-item"
                                                        v-bind:class="{
                                                            'slider-item': [1, 2].includes(
                                                                module.layout.type
                                                            ),
                                                            'col__width--full': [3, 4].includes(
                                                                module.layout.type
                                                            ),
                                                            'col__width--half': [5, 6].includes(
                                                                module.layout.type
                                                            )
                                                        }"
                                                    >
                                                        <div
                                                            class="awards__teaser-box module__teaser-box module__teaser-box--vertical"
                                                        >
                                                            <div
                                                                v-if="items__value.data"
                                                                class="awards_teaser-box-inner module__teaser-box-inner"
                                                            >
                                                                <component
                                                                    :is="
                                                                        items__value.data &&
                                                                        items__value.data.name &&
                                                                        items__value.data.file
                                                                            ? 'a'
                                                                            : 'div'
                                                                    "
                                                                    :href="
                                                                        items__value.data.file
                                                                            ? generateMediaUrl({
                                                                                  id:
                                                                                      items__value
                                                                                          .data.file
                                                                                          .id
                                                                              })
                                                                            : ''
                                                                    "
                                                                    target="_blank"
                                                                    class="awards__list-item-icon-wrapper"
                                                                >
                                                                    <app-moduleicon
                                                                        v-if="
                                                                            [3, 4, 5, 6].includes(
                                                                                module.layout.type
                                                                            )
                                                                        "
                                                                        :data="{
                                                                            id: getRandomImageInNamespace(
                                                                                'icons/awards/default'
                                                                            )
                                                                        }"
                                                                        :custom-class="
                                                                            'awards__list-item-icon module__icon'
                                                                        "
                                                                    ></app-moduleicon>
                                                                </component>
                                                                <div
                                                                    class="awards__teaser-box-text module__teaser-box-text"
                                                                >
                                                                    <component
                                                                        :is="
                                                                            items__value.data &&
                                                                            items__value.data
                                                                                .name &&
                                                                            items__value.data.file
                                                                                ? 'a'
                                                                                : 'div'
                                                                        "
                                                                        :href="
                                                                            items__value.data.file
                                                                                ? generateMediaUrl({
                                                                                      id:
                                                                                          items__value
                                                                                              .data
                                                                                              .file
                                                                                              .id
                                                                                  })
                                                                                : ''
                                                                        "
                                                                        target="_blank"
                                                                        class="awards__list-item-label module__label font-bold color-p"
                                                                    >
                                                                        {{ items__value.data.name }}
                                                                    </component>
                                                                    <a
                                                                        v-if="
                                                                            items__value.data
                                                                                .linkActive == 1 &&
                                                                                items__value.data
                                                                                    .link !==
                                                                                    undefined &&
                                                                                items__value.data
                                                                                    .link !==
                                                                                    null &&
                                                                                items__value.data
                                                                                    .link !== '' &&
                                                                                items__value.data
                                                                                    .linkText !==
                                                                                    undefined &&
                                                                                items__value.data
                                                                                    .linkText !==
                                                                                    null &&
                                                                                items__value.data
                                                                                    .linkText !==
                                                                                    '' &&
                                                                                items__value.data
                                                                                    .link !==
                                                                                    'https://www.tecworld.com'
                                                                        "
                                                                        :href="
                                                                            items__value.data
                                                                                .link || ''
                                                                        "
                                                                        class="awards__link module__label color-p"
                                                                        target="_blank"
                                                                    >
                                                                        <span>
                                                                            {{
                                                                                items__value.data
                                                                                    .linkText
                                                                            }}
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="awards__inner-row module__inner-row"
                        v-if="
                            [1, 2, 3, 4].includes(module.layout.type) &&
                                ((module.data.link && module.data.link.active) ||
                                    (module.data.link2 && module.data.link2.active) ||
                                    (module.data.link3 && module.data.link3.active))
                        "
                    >
                        <div class="awards__inner-col module__inner-col">
                            <div class="awards__cta module__cta">
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link"
                                    :custom-class="
                                        'awards__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link2"
                                    :custom-class="
                                        'awards__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 3, 4].includes(module.layout.type)"
                                    :data="module.data.link3"
                                    :custom-class="
                                        'awards__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleicon': ModuleIcon,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems', 'getRandomImageInNamespace', 'generateMediaUrl']),
        items() {
            return this.getListItems('deha.user.misc.awards');
        }
    },
    props: {
        module: Object
    }
};
</script>
